import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AnnotationsService } from '../services/annotations.service';
import * as AnnotationsActions from '../actions/annotations.actions';

@Injectable()
export class AnnotationsEffects {
  private actions$ = inject(Actions);
  private annotationsService = inject(AnnotationsService);

  loadAnnotations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AnnotationsActions.loadAnnotations),
      switchMap(() =>
        this.annotationsService.getAnnotations().pipe(
          map((annotations) =>
            AnnotationsActions.loadAnnotationsSuccess({ annotations })
          ),
          catchError((error) =>
            of(AnnotationsActions.loadAnnotationsFailure({ error }))
          )
        )
      )
    );
  });
}
